import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Minus, Plus } from "lucide-react";
import { useApp } from "../context/AppContext";
import { api, errMsg, useFetch } from "../lib/api";
import { addDays, toISO } from "../lib/fmt";
import { PageHeader, Field } from "../components/bits";

export default function MissionForm() {
  const { sp } = useApp();
  const nav = useNavigate();
  const { data: homes } = useFetch(sp("/homes"));
  const [f, setF] = useState({ title: "", home_name: "", date: toISO(addDays(new Date(), 1)), start: "07:00", end: "15:00", needed: 1, comment: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(sp("/missions"), f);
      toast.success("Mission publiée · l'équipe est prévenue");
      nav(`/missions/${data.id}`, { replace: true });
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <div data-testid="mission-form-page">
      <PageHeader title="Nouvelle mission" back="/missions" />
      <form onSubmit={submit} className="space-y-5">
        <Field label="Intitulé (facultatif)"><input className="field" placeholder="Ex. Renfort matin" value={f.title} onChange={(e) => set("title", e.target.value)} data-testid="mission-title-input" /></Field>
        <Field label="Établissement ou structure">
          <input className="field" list="homes-list" required placeholder="Ex. Résidence Les Acacias" value={f.home_name} onChange={(e) => set("home_name", e.target.value)} data-testid="mission-home-input" />
          <datalist id="homes-list">{(homes || []).map((h) => <option key={h.id} value={h.name} />)}</datalist>
        </Field>
        <Field label="Date"><input type="date" className="field" value={f.date} onChange={(e) => set("date", e.target.value)} required data-testid="mission-date-input" /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Début"><input type="time" className="field" value={f.start} onChange={(e) => set("start", e.target.value)} required data-testid="mission-start-input" /></Field>
          <Field label="Fin"><input type="time" className="field" value={f.end} onChange={(e) => set("end", e.target.value)} required data-testid="mission-end-input" /></Field>
        </div>
        <Field label="Personnes recherchées">
          <div className="flex items-center gap-4">
            <button type="button" className="btn-ghost !px-4" onClick={() => set("needed", Math.max(1, f.needed - 1))} data-testid="mission-needed-minus" aria-label="Moins"><Minus className="h-4 w-4" /></button>
            <span className="w-8 text-center font-display text-2xl font-extrabold" data-testid="mission-needed-value">{f.needed}</span>
            <button type="button" className="btn-ghost !px-4" onClick={() => set("needed", f.needed + 1)} data-testid="mission-needed-plus" aria-label="Plus"><Plus className="h-4 w-4" /></button>
          </div>
        </Field>
        <Field label="Description (facultatif)"><input className="field" value={f.comment} onChange={(e) => set("comment", e.target.value)} placeholder="Ex. arriver à 6h50" data-testid="mission-comment-input" /></Field>
        <button className="btn-primary w-full !min-h-[60px] text-lg uppercase tracking-wide" disabled={busy} data-testid="mission-publish-btn">Publier</button>
      </form>
    </div>
  );
}
